

$(document).ready(function(){
  
const desktopCartTotal = document.querySelector('.cart_total.d-sm-flex.d-none .cart_subtotal_price.label_right')
const mobileCartTotal = document.querySelector('.cart_bottom_sticky .cart_subtotal_price.label_right') 

const finalPriceCheck = setInterval(function () {
  
  let appCode = document.querySelector('.appikon-messages .summary-line-discount')

    if (appCode !== null) { 
      mobileCartTotal.innerHTML = desktopCartTotal.innerHTML
      clearInterval(finalPriceCheck)
    }
}, 200)

finalPriceCheck()


//   $(window).scroll(function(){
//     var   scroll = $(window).scrollTop();
//     if (scroll >= 100){
//       $(".stcky_header").addClass("fixed")
//     }else{
//       $(".stcky_header").removeClass("fixed")
//     }
//   })
  
})

const mobileNavigation = document.querySelector('.main-mobile-navigation')

const parentLinks = document.querySelectorAll('.link-parent')
const childrenContainers = document.querySelectorAll('.link-children')
const backLinks = document.querySelectorAll('.back-to-main');
const mobileSnippet = document.querySelector('.snippet-mobile-menu');



parentLinks.forEach((link) => { 
  link.addEventListener('click', (event) => {
    link.nextElementSibling.classList.add('shown-child')
	mobileNavigation.classList.add('go-deep')
  mobileSnippet.style.overflowY="scroll";
  })
})


backLinks.forEach((link) => { 
  link.addEventListener('click', (event) => {
    console.log(link.parentElement.classList)
    console.log(mobileNavigation, 2)
    childrenContainers.forEach((element) => {
      element.classList.remove('shown-child')
    })
//     link.parentElement.classList.remove('shown-child')
	mobileNavigation.classList.remove('go-deep')
  mobileSnippet.style.overflowY="hidden";
  })
})
const close_btn_announcement_bar = document.querySelector('#close-icon-announcment');
const top_bar = document.querySelector('.top_bar_test');
close_btn_announcement_bar.addEventListener('click', ()=>{
  top_bar.classList.add('move_el_top')
});




 fetch("https://api.ipify.org?format=json").then((response) => {
          return response.json();
      }).then((data) => {
          let Ip_address = data.ip;	
          let APi_token = "b40e3566ae38301662c458b1333a8654";
          fetch(`http://api.ipstack.com/${Ip_address}?access_key=${APi_token}`).then((response) => {
              return response.json();
          }).then((data) => {
              let over_fifty = ["Netherlands", "Belgium", "Germany", "Luxembourg"];
              let over_seventyFive = ["Austria", "Bulgaria", "Croatia", "Cyprus", "Czechia", "Denmark", "Estonia", "Finland", "France", "Greece", "Hungary", "Ireland", "Italy", "Latvia", "Lithuania", "Luxembourg", "Malta", "Poland", "Portugal", "Romania", "Slovakia","Slovenia", "Sweden"]
              var Get_location_country = data.country_name;
              let apend_text,amout,shipping_amout;
              if(over_fifty.includes(Get_location_country)){
                amout = document.querySelector("input[name='selected_country']").value;
                apend_text = `Order for €<span>${amout}</span> more to get free shipping`;
                if(Get_location_country == "Netherlands"){
                  shipping_amout = "5.95";
                }else{
                  shipping_amout = "5.95";
                } 
              }else if(over_seventyFive.includes(Get_location_country)){
                  amout = document.querySelector("input[name='restof_Europe_countries']").value;
                  shipping_amout = "9.95";
                   apend_text = `Order for €<span>${amout}</span> more to get free shipping`;
              }else{
                  amout = document.querySelector("input[name='other_countries']").value;
                  shipping_amout = "5.95";
                  apend_text = `Order for €<span>${amout}</span> more to get free shipping`;
              }
              document.querySelector(".extra-cart-notification").setAttribute("data-amount",amout)
              document.querySelector(".cart-shipping.cart__item--subtotal").setAttribute("data-shipping",shipping_amout)
              document.querySelector(".cart-shipping.cart__item--subtotal div[data-shipping] span").innerHTML = shipping_amout;
              document.querySelector(".extra-cart-notification").innerHTML = apend_text;
          }).catch((error) => {
              console.log("error",error)
          })
      })

//  fetch("https://api.ipify.org?format=json").then((response) => {
//     return response.json();
// }).then((data) => {
//     let Ip_address = data.ip;	
//     let APi_token = "b40e3566ae38301662c458b1333a8654";
//     fetch(`http://api.ipstack.com/${Ip_address}?access_key=${APi_token}`).then((response) => {
//         return response.json();
//     }).then((data) => {
//         let over_fifty = ["Netherlands", "Belgium", "Germany", "Luxembourg"];
//         let over_seventyFive = ["Austria", "Bulgaria", "Croatia", "Cyprus", "Czechia", "Denmark", "Estonia", "Finland", "France", "Greece", "Hungary", "Ireland", "Italy", "Latvia", "Lithuania", "Luxembourg", "Malta", "Poland", "Portugal", "Romania", "Slovakia","Slovenia", "Sweden"]
//         var Get_location_country = data.country_name;
//         let apend_text,amout,shipping_amout;

//         console.log(data,"data----");
      
//         if(over_fifty.includes(Get_location_country)){
//           amout = document.querySelector("input[name='selected_country']").value;
//           apend_text = `Order for €<span>${amout}</span> more to get free shipping`;
//           if(Get_location_country == "Netherlands"){
//             shipping_amout = "2.95";
//           }else{
//             shipping_amout = "3.95";
//           } 
//         }else if(over_seventyFive.includes(Get_location_country)){
//             amout = document.querySelector("input[name='restof_Europe_countries']").value;
//             shipping_amout = "9.95";
//              apend_text = `Order for €<span>${amout}</span> more to get free shipping`;
//         }else{
//             amout = document.querySelector("input[name='other_countries']").value;
//             shipping_amout = "12.95";
//             apend_text = `Order for €<span>${amout}</span> more to get free shipping`;
//         }
//         document.querySelector(".extra-cart-notification").setAttribute("data-amount",amout)
//         document.querySelector(".cart-shipping.cart__item--subtotal").setAttribute("data-shipping",shipping_amout)
//         document.querySelector(".cart-shipping.cart__item--subtotal div[data-shipping] span").innerHTML = shipping_amout;
//         document.querySelector(".extra-cart-notification").innerHTML = apend_text;
//     }).catch((error) => {
//         console.log("error",error)
//     })
// })

document.addEventListener('DOMContentLoaded', () => {
  const zoomContainer = document.querySelector('.zoom-container');
  const closeZoomButton = document.getElementById('close-zoom');
  const zoomSlides = document.querySelectorAll('.zoom-slide');
  const mediaSlides = document.querySelectorAll('.slider_nav_product li');
  const rightArrow = document.querySelector('.right-arrow');
  const leftArrow = document.querySelector('.left-arrow');
  let currentIndex = 0;

  function isVideoSlide(slide) {
    return slide.querySelector('video') !== null;
  }

  function openZoom(index) {
    currentIndex = index;
    while (isVideoSlide(zoomSlides[currentIndex])) {
      currentIndex = (currentIndex + 1) % zoomSlides.length;
    }
    zoomContainer.style.display = 'block';
    document.body.classList.add('no-scroll');
    showSlide(currentIndex);
  }

  function closeZoom() {
    zoomContainer.style.display = 'none';
    document.body.classList.remove('no-scroll');
  }
  
  function showSlide(index) {
    zoomSlides.forEach((slide, i) => {
      if (i === index) {
        slide.classList.add('active');
        slide.style.transform = 'translateX(0)';
      } else {
        slide.classList.remove('active');
        slide.style.transform = `translateX(${(i - index) * 100}%)`;
      }
    });
  }

  function nextSlide() {
    do {
      currentIndex = (currentIndex + 1) % zoomSlides.length;
    } while (isVideoSlide(zoomSlides[currentIndex]));
    showSlide(currentIndex);
  }

  function prevSlide() {
    do {
      currentIndex = (currentIndex - 1 + zoomSlides.length) % zoomSlides.length;
    } while (isVideoSlide(zoomSlides[currentIndex]));
    showSlide(currentIndex);
  }

  rightArrow.addEventListener('click', nextSlide);
  leftArrow.addEventListener('click', prevSlide);

  closeZoomButton.addEventListener('click', closeZoom);
  

  mediaSlides.forEach(media => {
    media.addEventListener('click', () => {
      const count = media.getAttribute('data-count');
      const targetSlide = Array.from(zoomSlides).find(slide => {
        return slide.getAttribute('data-count') === count;
      });
      if (targetSlide) {
        let index = Array.from(zoomSlides).indexOf(targetSlide);
        if (isVideoSlide(targetSlide)) {
          index = (index + 1) % zoomSlides.length;
        }
        openZoom(index);
      }
    });
  });
});